import RestInputContextUI from 'components/form/RestInputContext';
import React from 'react';
import { DynamicObjectType } from 'types/commons';

export interface ICreateForm {
  record?: DynamicObjectType;
  children?: React.ReactNode;
  onSubmit?: (values: DynamicObjectType) => void;
  handleSubmitFailed?: (values: DynamicObjectType) => void;
  handleDataConvert?: (record?: DynamicObjectType) => void;
  isEdit?: boolean;
}

export default function RestForm({
  handleSubmitFailed,
  children,
  record,
  onSubmit,
  handleDataConvert,
  isEdit,
}: ICreateForm) {
  return (
    <RestInputContextUI
      handleSubmitFailed={handleSubmitFailed}
      onSubmit={onSubmit}
      record={record}
      handleDataConvert={handleDataConvert}
      isEdit={isEdit}
    >
      {children}
    </RestInputContextUI>
  );
}
